import React from "react";

import {SamplesUIProvider} from "../../contexts/SamplesUIContext";
import {SamplesContainer} from "../../components/containers/SamplesContainer";
import {SampleDetailModal} from "../../components/modules/SampleDetailModal";

import {URLs} from "../../../utils/routes";
import {Route} from "react-router-dom";

export function SamplesPage({history}) {
  const uiEvents = {
    openSampleDetailDialog: (id) => {
      history.push(`${URLs.SERVICES_SAMPLES}/${id}`);
    },
  };

  return (
    <SamplesUIProvider uiEvents={uiEvents}>
      <SamplesContainer/>

      <Route path={URLs.SERVICES_SAMPLE_DETAIL}>
        {({ history, match }) => match ? (
          <SampleDetailModal
            show={true}
            sampleId={match.params.sampleId}
            onHide={() => history.goBack()}
          />
        ) : null}
      </Route>
    </SamplesUIProvider>
  )
}
